import React from "react";
import { Link } from "react-router-dom";
import { Cards } from "../components/Cards.tsx";
import { canViewCareNotesReports } from "../utils/careNotesReport.js";

const userGroups = () => {
  const userString = localStorage.getItem("user");
  return userString ? JSON.parse(userString)?.userGroup || [] : [];
};

export default function Reports() {
  if (!canViewCareNotesReports(userGroups())) {
    return <p>You do not have permission to view reports.</p>;
  }

  return (
    <div className="d-flex flex-wrap" style={{ gap: "16px" }}>
      <Cards>
        <h5 className="mb-16">Care Notes Reports</h5>
        <p className="mb-16">Filter, review and print care notes</p>
        <Link className="btn btn__primary" to="/reports/care-notes">
          Open report
        </Link>
      </Cards>
    </div>
  );
}
